/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import {
  findDevices,
  LocalizePropType,
  selectConnectDevices,
  selectCurrentInstallation,
  selectSelectedConnectCar,
  setSelectedConnectDevice,
  updateCarInstallation,
  withTextLocalizer,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import SelectDeviceView from './SelectDeviceView';
import { navigateTo } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { AutocompleteOption } from '../../components/TextAutocomplete/TextAutocomplete';

type Props = {
  localize: LocalizePropType;
};

const SelectDeviceContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedCar = useSelector(selectSelectedConnectCar);
  const devices = useSelector(selectConnectDevices);
  const currentInstallation = useSelector(selectCurrentInstallation);

  const [deviceNo, setDeviceNo] = React.useState<string | null>(null);
  const [inputValue, setInputValue] = React.useState('');

  const continueInstallation = () => {
    navigateTo(history, '/test');
  };

  const onPressContinue = () => {
    if (deviceNo === currentInstallation?.device?.serialNumber) {
      continueInstallation();
    } else {
      const selectedDevice = devices.find(
        (device) => device.serialNumber === deviceNo
      );
      dispatch(
        updateCarInstallation(
          selectedCar?.id!,
          { deviceId: selectedDevice?.id },
          () => {
            continueInstallation();
          }
        )
      );
      dispatch(setSelectedConnectDevice(selectedDevice!));
    }
  };

  const handleChange = (event: any, newValue: AutocompleteOption | null) => {
    setDeviceNo(newValue?.value!);
  };

  const handleInputChange = (event: any, newValue: string) => {
    setInputValue(newValue);
  };

  useEffect(() => {
    dispatch(findDevices());
    dispatch(setSelectedConnectDevice(null));
  }, []);

  useEffect(() => {
    if (currentInstallation?.device) {
      setDeviceNo(currentInstallation?.device?.serialNumber!);
    }
    if (!currentInstallation) {
      navigateTo(history, '/select');
    }
  }, [currentInstallation]);

  return (
    <SelectDeviceView
      localize={localize}
      devices={devices}
      deviceNo={deviceNo}
      inputValue={inputValue}
      handleChange={handleChange}
      handleInputChange={handleInputChange}
      onPressContinue={onPressContinue}
    />
  );
};

export default withTextLocalizer(SelectDeviceContainer);
